/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coaches_Week_HideInputs */

const en_portal_coaches_week_hide = /** @type {(inputs: Portal_Coaches_Week_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide the times`)
};

const pl_portal_coaches_week_hide = /** @type {(inputs: Portal_Coaches_Week_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwiń terminy`)
};

/**
* | output |
* | --- |
* | "Hide the times" |
*
* @param {Portal_Coaches_Week_HideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coaches_week_hide = /** @type {((inputs?: Portal_Coaches_Week_HideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coaches_Week_HideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coaches_week_hide(inputs)
	return en_portal_coaches_week_hide(inputs)
});